import {
  ArrowDownCircleIcon,
  ArrowDownIcon,
  ChartPieIcon,
  ChevronDownIcon,
  ChevronUpIcon,
} from "@heroicons/react/24/outline"
import { ArrowUpIcon } from "@heroicons/react/24/solid"
import React, { FC } from "react"

type Props = {
  title: string
  number: number
  percent: number
  icon: JSX.Element | JSX.Element[]
  icon_color: string
  p_color: string
}

export const StatisticsCard: FC<Props> = ({
  title,
  number,
  icon,
  icon_color,
  percent,
}) => {
  return (
    <div className="dark:bg-primary-1 bg-white dark:border-2 relative shadow-md dark:border-secondary-11 rounded-lg 2xl:p-7 2xl:pb-8 lg:p-5 px-5 py-4">
      <h1 className=" dark:text-primary-10 text-light-2 2xl:text-lg text-base mb-2">
        {title}
      </h1>
      <div className="flex items-center justify-between py-2">
        <div className="flex gap-x-6 items-center">
          <div
            className={`w-10 dark:bg-secondary-13 bg-white ${icon_color} rounded-full p-1`}
          >
            {icon}
          </div>
          <h3 className="2xl:text-4xl xl:text-3xl text-2xl dark:text-white text-light-2">
            {number.toFixed(2)}
          </h3>
          {percent !== 0 && percent !== null && (
            <div
              className={`flex dark:text-white text-xs items-center gap-x-1 absolute right-5 ${
                title === "Total Quotes" ? "text-accent" : ""
              }`}
            >
              {percent > 0 ? (
                <ArrowUpIcon
                  className={`w-3 h-3 ${
                    title === "Total Quotes"
                      ? "text-accent"
                      : `${
                          title === "Total Booked"
                            ? "text-[#0B6391]"
                            : `${
                                title === "New Customers"
                                  ? "text-[#9A3FF4]"
                                  : `${
                                      title === "Avg Daily Quotes"
                                        ? "text-[#9A3FF4]"
                                        : `${
                                            title === "Average Daily Booked"
                                              ? "text-[#07A45B]"
                                              : `${
                                                  title === "Error"
                                                    ? "text-[#F12E51]"
                                                    : ""
                                                }`
                                          }`
                                    }`
                              }`
                        } `
                  }`}
                />
              ) : (
                <ArrowDownIcon
                  className={`w-3 h-3 ${
                    title === "Total Quotes"
                      ? "text-accent"
                      : `${
                          title === "Total Booked"
                            ? "text-[#0B6391]"
                            : `${
                                title === "New Customers"
                                  ? "text-[#9A3FF4]"
                                  : `${
                                      title === "Avg Daily Quotes"
                                        ? "text-[#9A3FF4]"
                                        : `${
                                            title === "Average Daily Booked"
                                              ? "text-[#07A45B]"
                                              : `${
                                                  title === "Error"
                                                    ? "text-[#F12E51]"
                                                    : ""
                                                }`
                                          }`
                                    }`
                              }`
                        } `
                  }`}
                />
              )}
              <div
                className={`flex gap-x-0 ${
                  title === "Total Quotes"
                    ? "text-accent"
                    : `${
                        title === "Total Booked"
                          ? "text-[#0B6391]"
                          : `${
                              title === "New Customers"
                                ? "text-[#9A3FF4]"
                                : `${
                                    title === "Avg Daily Quotes"
                                      ? "text-[#9A3FF4]"
                                      : `${
                                          title === "Average Daily Booked"
                                            ? "text-[#07A45B]"
                                            : `${
                                                title === "Error"
                                                  ? "text-[#F12E51]"
                                                  : ""
                                              }`
                                        }`
                                  }`
                            }`
                      } `
                }`}
              >
                {percent} <span>%</span>
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  )
}
